import styled, { css } from 'styled-components';

import {
    CommonAction,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesCommonAction,
    styledMedia,
    styledTypography,
} from '@pkg/primitives';

interface ActionProps {
    $iconOnly?: boolean;
    $large?: boolean;
}

export const Action = styled(CommonAction)<ActionProps>`
    ${recipesCommonAction.basic};

    --action-gap: 6px;
    --action-height: 40px;
    --icon-size: 16px;
    --font-size: 14px;

    position: relative;
    gap: var(--action-gap);
    width: 100%;
    height: var(--action-height);
    background-color: rgb(255, 255, 255, 0.06);

    &:disabled {
        opacity: 0.8;
    }

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.1);
    }

    ${({ $iconOnly }) =>
        $iconOnly &&
        css`
            width: var(--action-height);
        `};

    ${({ $large }) =>
        $large &&
        css`
            --action-gap: 10px;
            --action-height: 60px;
            --icon-size: 20px;
            --font-size: 18px;
        `};

    // Loading spinner
    > div[data-spinner='simple'] {
        position: absolute;
        align-self: center;
        justify-self: center;
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: var(--icon-size);
    height: var(--icon-size);
    transition: opacity ${duration.normal}ms ${easing.cubic};

    ${Action}:disabled & {
        opacity: 0;
    }
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: var(--font-size);
    font-weight: 700;
    letter-spacing: -0.02em;
    transition: opacity ${duration.normal}ms ${easing.cubic};

    ${Action}:disabled & {
        opacity: 0;
    }
`;
